<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/clients">Clients</router-link>
                    </li>
                    <template v-if="!client.id">
                        <vue-headful :title="'Create Client - AMOS365'" />

                        <li class="breadcrumb-item active" aria-current="page">Create</li>
                    </template>
                    <template v-else>
                        <vue-headful :title="'[Edit Client] ' + client.first_name + ' '+client.last_name+' - AMOS365'" />

                        <li class="breadcrumb-item">
                            <router-link :to="`/clients/view/${client.id}`">{{ client.first_name }} {{ client.last_name }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">Edit</li>
                    </template>

                </ol>
            </nav>

            <h4 class="page-header">
                <span v-if="id">Edit: {{ client.first_name }} {{ client.last_name }}</span>
                <span v-else>New Client</span>
            </h4>

            <div class="row mb-4">
                <div class="col-md-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Details:</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.first_name, 'text-muted-no': !errors.first_name}">
                                    First Name: <i class="fa fa-sm fa-asterisk text-danger" v-if="!client.first_name"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="client.first_name" :class="{'form-control': true, 'is-invalid': errors.first_name}" placeholder="Enter Client First Name" />

                                    <div class="text-danger mt-2" v-if="errors.first_name">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.first_name">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.last_name, 'text-muted-no': !errors.last_name}">
                                    Last Name: <i class="fa fa-sm fa-asterisk text-danger" v-if="!client.last_name"></i>
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="client.last_name" :class="{'form-control': true, 'is-invalid': errors.last_name}" placeholder="Enter Client Last Name" />

                                    <div class="text-danger mt-2" v-if="errors.last_name">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.last_name">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.middle_name, 'text-muted-no': !errors.middle_name}">
                                    Middle Name:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="client.middle_name" :class="{'form-control': true, 'is-invalid': errors.middle_name}" placeholder="Enter Client Middle Name" />

                                    <div class="text-danger mt-2" v-if="errors.middle_name">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.middle_name">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.spouse_name, 'text-muted-no': !errors.spouse_name}">
                                    Spouse Name:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="client.spouse_name" :class="{'form-control': true, 'is-invalid': errors.spouse_name}" placeholder="Enter Client Spouse Name" />

                                    <div class="text-danger mt-2" v-if="errors.spouse_name">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.spouse_name">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.number_of_children, 'text-muted-no': !errors.number_of_children}">
                                    Number of Children:
                                </div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="client.number_of_children" :class="{'form-control': true, 'is-invalid': errors.number_of_children}" placeholder="Enter Number of Children" />

                                    <div class="text-danger mt-2" v-if="errors.number_of_children">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.number_of_children">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-1">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.is_active, 'text-muted-no': !errors.is_active}">Active:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <b-form-checkbox v-model="client.is_active" :value="1" :unchecked-value="0" plain />

                                    <div class="text-danger mt-2" v-if="errors.is_active">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.is_active">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Identification:</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.medicare, 'text-muted-no': !errors.medicare}">Medicare:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="text" v-model="client.medicare" :class="{'form-control': true, 'is-invalid': errors.medicare}" placeholder="Enter Resident License#" />

                                    <div class="text-danger mt-2" v-if="errors.medicare">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.medicare">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-3" v-if="$root.hasPermission('clients.view.sensitive')">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.ssn, 'text-muted-no': !errors.ssn}">SSN:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <the-mask :mask="'XXX-XX-XXXX'" v-model="client.ssn" :class="{'form-control': true, 'is-invalid': errors.ssn}" placeholder="Enter SSN" />

                                    <div class="text-danger mt-2" v-if="errors.ssn">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.ssn">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-3" v-if="$root.hasPermission('clients.view.sensitive')">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.date_of_birth, 'text-muted-no': !errors.date_of_birth}">Date of Birth:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="date" v-model="client.date_of_birth" :class="{'form-control': true, 'is-invalid': errors.date_of_birth}" placeholder="Enter Client Date of Birth" />

                                    <div class="text-danger mt-2" v-if="errors.date_of_birth">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.date_of_birth">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-3" v-if="$root.hasPermission('clients.view.sensitive')">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.spouse_ssn, 'text-muted-no': !errors.spouse_ssn}">Spouse SSN:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <the-mask :mask="'###-##-####'" v-model="client.spouse_ssn" :class="{'form-control': true, 'is-invalid': errors.spouse_ssn}" placeholder="Enter Spouse SSN" />

                                    <div class="text-danger mt-2" v-if="errors.spouse_ssn">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.spouse_ssn">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-3" v-if="$root.hasPermission('clients.view.sensitive')">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.spouse_date_of_birth, 'text-muted-no': !errors.spouse_date_of_birth}">Spouse Date of Birth:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <input type="date" v-model="client.spouse_date_of_birth" :class="{'form-control': true, 'is-invalid': errors.spouse_date_of_birth}" placeholder="Enter Spouse Date of Birth" />

                                    <div class="text-danger mt-2" v-if="errors.spouse_date_of_birth">
                                        <ul class="list-unstyled mb-0">
                                            <li v-for="err in errors.spouse_date_of_birth">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Notes</strong>
                        </div>
                        <div class="card-body">
                            <b-form-textarea v-model="client.notes" :class="{'is-invalid': errors.notes}" placeholder="Enter Client Notes" rows="3"></b-form-textarea>
                        </div>
                    </div>

                    <files-add ref="clientEditFiles" :rowClass="'col-lg-4 col-md-6 col-12'" :sensitive="true" />
                </div>

                <div class="col-md-4 col-12 mt-md-0 mt-4">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Email ({{ emails.length }})</strong>

                            <div class="actions pull-right">
                                <button type="button" class="btn btn-sm btn-default" v-on:click="$refs.emailEditor.addEmail()"><i class="fa fa-plus-circle"></i> Add</button>
                            </div>
                        </div>
                        <div class="card-body">
                            <email-editor ref="emailEditor" :emails="emails" />
                        </div>
                    </div>
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Phone Numbers ({{ phones.length }})</strong>

                            <div class="actions pull-right">
                                <button type="button" class="btn btn-sm btn-default" v-on:click="$refs.phoneEditor.addPhone()"><i class="fa fa-plus-circle"></i> Add</button>
                            </div>
                        </div>
                        <div class="card-body">
                            <phone-editor ref="phoneEditor" :phones="phones" />
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Address ({{ addresses.length }})</strong>

                            <div class="actions pull-right">
                                <button type="button" class="btn btn-sm btn-default" v-on:click="$refs.addressEditor.addAddress()"><i class="fa fa-plus-circle"></i> Add</button>
                            </div>
                        </div>
                        <div class="card-body">
                            <address-editor ref="addressEditor" :addresses="addresses" :states="states" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-4">
                <button type="button" class="btn btn-sm btn-success" v-if="!id" v-on:click="saveClient()" :disabled="saving">
                    <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Saving...</template>
                    <template v-else><i class="fas fa-save"></i> Create</template>
                </button>
                <button type="button" class="btn btn-sm btn-success" v-if="id" v-on:click="saveClient()" :disabled="saving">
                    <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Saving...</template>
                    <template v-else><i class="fas fa-save"></i> Update</template>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
    import {TheMask} from 'vue-the-mask';

    export default {
        components: {TheMask},
        data() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                client: {},
                errors: {},
                states: [],
                addresses: [],
                emails: [],
                phones: [],
                files: [],
            }
        },

        computed: {
            stateOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a State --'}];

                //Main Loop
                for(var i = 0; i < this.states.length; i++)
                {
                    options.push({value: this.states[i].id, text: this.states[i].state_name});
                }

                //Send it
                return options;
            },
        },

        methods: {

            getClient(){
                //Send it
                this.$http.get('/clients/edit' + (this.id ? '/'+this.id : ''))
                    .then(response => {
                        //Set the client
                        this.client = response.data.client;
                        this.addresses = response.data.addresses;
                        this.emails = response.data.emails;
                        this.phones = response.data.phones;
                        this.states = response.data.states;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            saveClient(){
                //Helpers
                this.saving = true;
                this.errors = {};
                this.$refs.emailEditor.setErrors({});
                this.$refs.phoneEditor.setErrors({});
                this.$refs.addressEditor.setErrors({});

                //Append Stuff to the Payload
                this.client.emails = this.$refs.emailEditor.getEmails();
                this.client.phones = this.$refs.phoneEditor.getPhones();
                this.client.addresses = this.$refs.addressEditor.getAddresses();

                //Get it
                var file_data = this.$refs.clientEditFiles.getFilesForSave();

                //Set
                this.client.file_names = file_data.file_names;
                this.client.file_sensitive = file_data.file_sensitive;

                //Send it
                this.$http
                .postWithFiles('clients/save', this.client, file_data.files)
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('Client ' + (this.client.id ? 'Updated' : 'Created') );

                    //Return to main list?
                    this.$router.push('/clients/view/' + response.data.id);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;

                        //Set the errors for the component editors
                        this.$refs.emailEditor.setErrors(this.errors);
                        this.$refs.phoneEditor.setErrors(this.errors);
                        this.$refs.addressEditor.setErrors(this.errors);

                        //Alert
                        this.$toastr.e('Validation Errors Occurred');
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to Save Client');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            addAddress(){
                //Push
                this.addresses.push({address: '', city: '', state_id: null, zip: '', is_primary: 0});
            },

            deleteAddress(i){
                //Confirm
                if(!confirm('Are you sure you want to delete this address: '+this.addresses[i].address))
                {
                    return;
                }

                //Splice
                this.addresses.splice(i, 1);
            },

            addEmail(){
                //Push
                this.emails.push({email: '', is_primary: 0});
            },

            deleteEmail(i){
                //Confirm
                if(!confirm('Are you sure you want to delete this email: '+this.emails[i].email))
                {
                    return;
                }

                //Splice
                this.emails.splice(i, 1);
            },

            addPhone(){
                //Push
                this.phones.push({phone: '', is_primary: 0, phone_type: null});
            },

            deletePhone(i){
                //Confirm
                if(!confirm('Are you sure you want to delete this phone number: '+this.phones[i].phone))
                {
                    return;
                }

                //Splice
                this.phones.splice(i, 1);
            },
        },

        mounted() {
            //get the client?
            this.getClient();
        }
    }
</script>
